import { createApp } from 'vue';
import LoginForm from '@/components/LoginForm.vue';
import '@/boot_axios';
import '@/boot_sentry';

// oxlint-disable-next-line typescript/no-unsafe-argument -- tsgolint can't type .vue SFC imports
createApp(LoginForm)
    .mount('#app');
